// Brazilian phone numbers typed into a message — "(32) 99999-8888", "+55 32 99999-8888",
// "32999998888" — so an agent can start a conversation with a number a customer sent, the way
// the Fátima CRM did. Only numbers that look like a real Brazilian phone are taken: CPF, order
// numbers and dates share the digits and would otherwise turn into links.

// A run of digits with the separators people type in phone numbers. It may not touch a word,
// an e-mail or a URL on either side.
export const PHONE_CANDIDATE =
  /(?<![\w@./])\+?\(?\d[\d\s().-]{8,18}\d(?![\w@/])/g;

// Returns the number as "+55DDNNNNNNNNN", or null when the text is not a Brazilian phone.
export const canonicalBrazilianPhone = text => {
  const digits = String(text).replace(/\D/g, '');
  const hasCountry = digits.length >= 12 && digits.startsWith('55');
  if (!hasCountry && digits.length > 11) return null;

  let national = hasCountry ? digits.slice(2) : digits;
  if (national.length !== 10 && national.length !== 11) return null;

  // Area codes run from 11 to 99 and none has a zero in it.
  if (national[0] === '0' || national[1] === '0') return null;

  const first = national[2];
  if (national.length === 11) {
    // Eleven digits is a mobile, which always starts with 9. A CPF has eleven digits too.
    if (first !== '9') return null;
  } else if (/[6-9]/.test(first)) {
    // A mobile written without the ninth digit, as older contacts still are.
    national = `${national.slice(0, 2)}9${national.slice(2)}`;
  } else if (!/[2-5]/.test(first)) {
    return null;
  }

  return `+55${national}`;
};
